import "./ContactHero.css";

function ContactHero({ eyebrow, title, text }) {
  return (
    <section className="contact-hero-container fade-in-up">
      <div className="contact-hero-panel hover-lift">
        {eyebrow && <span className="contact-hero-eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        <p>{text}</p>
      </div>
    </section>
  );
}

export default ContactHero;
